// components/GlobalError.js
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { clearError } from "../../redux/slices/errorSlice";
import { WarningFilled, CloseIcon } from "./Icons";

const ErrorContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  max-width: 449px;
  background-color: #161718;
  color: #fff;
  padding: 12px 16px;
  // border: 1px solid #f5c6cb;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 2000;
`;

const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ErrorText = styled.p`
  margin: 0; /* Override default margin */
  font-size: 14px; /* Customize font size */
  color: #fff; /* Ensure consistent color */
  line-height: 1.5; /* Adjust line height for better readability */
`;

const CloseIconStyled = styled.div`
  cursor: pointer; /* Change cursor to pointer on hover */
  &:hover {
    opacity: 0.8; /* Add some visual feedback when hovering */
  }
`;

const GlobalError = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.error);

  // Don't show for 409 errors or when there's no message
  if (
    !error.message ||
    error.message === "This care plan is already locked." ||
    error.message ===
      "A draft care plan already exists for this active care plan."
  ) {
    return null;
  }

  // if (error.code === "This care plan is already locked.") {
  //   return null;
  // }

  const handleClose = () => {
    dispatch(clearError());
  };

  return (
    <ErrorContainer>
      <div className="error-message">
        <ErrorMessage>
          <WarningFilled />
          <ErrorText>{error.message}</ErrorText>
          <CloseIconStyled onClick={handleClose}>
            <CloseIcon />
          </CloseIconStyled>
        </ErrorMessage>
      </div>
    </ErrorContainer>
  );
};

export default GlobalError;
